"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_query_1 = require("@tanstack/react-query");
const useDonorContactInformation = (options) => {
    const { data: donorContactInformation } = (0, react_query_1.useQuery)(Object.assign({ queryKey: ['GetDonorContactInformation'], queryFn: () => axios.get('/api/get-donor-contact-information').then((response) => response.data.data.filter((x) => x)) }, options));
    return donorContactInformation || [];
};
exports.default = useDonorContactInformation;
